import Form from "../forms/form";
import React from "react";
import DOMPurify from "dompurify";
import MyCountdown from "../parts/countdown";
import FirstScreenBG from "../../img/wab_first_screen.jpg";
import {MdPlace} from "react-icons/md";
import {IoCalendar} from "react-icons/io5";
import 'animate.css';
import FirstScreenSpeacers from "../parts/firsrtscreen-speacers";
import FsBackgroundForm from "../../img/fs-form-backgound.png";

function FirstScreenSlider({fsData}) {

    return (
        fsData ?
            <section className="pb-20 z-30 relative pt-[100px] overflow-hidden xl:min-h-screen flex items-center" style={{
                background: 'url(' + FirstScreenBG + ')',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundAttachment: 'fixed'
            }} id="top">
                <div className="container px-3 max-w-screen-xl mx-auto overflow-hidden relative">
                    <div className="grid w-full grid-cols-1 lg:grid-cols-[55%,45%] items-end justify-end relative z-40">
                        <div className="lg:justify-self-start md:justify-self-center sm:mb-0 mb-10">
                            <h1 className="text-4xl mb-2 text-[#E7E9EC] uppercase max-w-[400px]">{fsData.fs_event_name}</h1>
                            <p className="text-[#E7E9EC] mb-4 text-xl sm:text-2xl lg:max-w-[550px]">{fsData.fs_description_slogan}</p>

                            {/*<a href="/" className="block w-full max-w-[400px] mb-6"><img src={LogoBig} alt="Logo HR Wisdom Summit"/></a>*/}

                            {/*<p className="text-[#E7E9EC] mb-4 text-2xl sm:text-5xl uppercase font-bold">{fsData.fs_description_name}</p>*/}


                            <div className="w-full lg:max-w-[550px]">
                                <div
                                    className="backdrop-blur pt-4 px-4 pb-8 bg-white overflow-hidden" style={{
                                    background: 'url(' + FsBackgroundForm + ')',
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'top right',
                                }}>

                                    <div className="flex mb-6 items-center">
                                        <div className="sm:mr-5 flex flex-wrap items-center">
                                            <div
                                                className="w-[35px] h-[35px] mr-[5px] p-2 flex items-center justify-center">
                                                <IoCalendar className="text-[30px] "/>
                                            </div>
                                            <div className="w-[calc(100%-40px)]">3 вересня - 29 жовтня 2026</div>
                                        </div>
                                        <div className="flex flex-wrap items-center relative">
                                            <div className="w-[35px] h-[35px] mr-[5px] p-2 flex items-center justify-center">
                                                <MdPlace
                                                    className="text-[30px]"/>
                                            </div>
                                            <div className="w-[calc(100%-40px)]">
                                                <p className="text-sm">Київ, online + offline</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/*<div className="countdown mb-4">
                                        <MyCountdown/>
                                    </div>*/}
                                    <div className="h-0.5 w-full /40"/>
                                        <Form/>
                                        {/*<div className="absolute top-0 -right-1/2 w-1/2 h-1/2 bg-[#bf42ba]/90 transform-gpu skew-x-[40deg] z-20"/>*/}
                                    </div>
                                <div
                                    className="bg-[#AF00A9] p-2 text-gray-200 font-light text-sm">
                                    <p>*Участь у проєкті безкоштовна за попередньою реєстрацією</p>
                                    <p>**🤟 Передбачено переклад жестовою мовою</p>
                                </div>
                            </div>

                        </div>
                        <FirstScreenSpeacers slider_data={fsData.fs_speacers_slider}/>

                    </div>
                </div>

                {/*<div className="absolute top-0 sm:-left-1/2 -left-3/4 w-full h-[100vw] bg-[#AF00A9]/80 transform-gpu -skew-x-[49deg]"></div>*/}

            </section> : ''
    )
}

export default FirstScreenSlider